
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class TopContentInformation extends Vue {
  @Prop({ type: Array, required: true })
  public list!: {
    label: string;
    values: string[];
  }[];
}
